<template>
  <div class="columns is-centered">
      <div class="column is-half">
        <b-field label="Enter Users To Remove Admin Privleges From">
        <b-taginput
            v-model="selectedUser"
            :data="filteredUsers"
            :loading="isSending"
            autocomplete
            :allow-new="false"
            :open-on-focus="true"
            field="email"
            icon="label"
            @typing="getFilteredUsers">
        </b-taginput>
      </b-field>
    <b-button 
        class="is-danger mt-4"
        :disabled="isSending" 
        @click="removeFromAdmin()">
        Remove Admin Privledges
    </b-button>
      </div>
  </div>
</template>

<script>
import { API } from 'aws-amplify'
import { removeFromAdmin } from '../graphql/mutations'
import { personReader } from '../graphql/queries'

export default {
    data(){
        return{
            users: [],
            filteredUsers: [],
            selectedUser: null,
            isSending: false
        }
    },
    methods: {
        async removeFromAdmin() {
            this.isSending = true
            for(let i = 0; i < this.selectedUser.length; i++){
            await API.graphql({
                query: removeFromAdmin,
                variables: {
                    input: {
                    username: this.selectedUser[i].cognito_id
                    }
                }
            });
            }
            this.selectedUser = []
            this.isSending = false
        },
        async getUsers() {
            const Users = await API.graphql({
                query: personReader,
                variables: {
                    input: {
                        request_type: 'read_all'
                    }
                }
            });
            this.users = Users.data.personReader;
        },
        getFilteredUsers(text) {
                this.filteredUsers= this.users.filter((option) => {
                    return option.email
                        .toString()
                        .toLowerCase()
                        .indexOf(text.toLowerCase()) >= 0
        })
        },
    },
    mounted(){
        this.getUsers()
    }
}
</script>

<style>

</style>